import Vue from 'vue';
import Router from 'vue-router';

import dashboard from '../components/dashboard.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: dashboard,
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js